import * as yup from 'yup';

export const createrestaurantSchema = yup.object().shape({
  name: yup
    .string()
    .required('Restaurant name is required')
    .matches(/[A-Z]/, 'Enter first letter capital'),
  // .matches(
  //   /^(?![0-9])(?!.*[0-9]$)(?!.*\d_)(?!.*_\d)[a-zA-Z0-9]+$/,
  //   "This field cannot contain white space and special character"
  // ),
  legal_entity_name: yup.string().required('Legal Entity Name is required'),
  country_id: yup.string().required('Country name is required'),
  state_id: yup.string().required('State name is required'),
  time_zone: yup.string().required('Time zone is required'),
  mobile: yup.number().typeError('Mobile number is required'),
  email: yup.string().required('Email is required'),
});

export const editSchema = yup.object().shape({
  name: yup.string().required('Restaurant name is required'),
  legal_entity_name: yup.string().required('Legal Entity Name is required'),
  // .matches(
  //   /^(?![0-9])(?!.*[0-9]$)(?!.*\d_)(?!.*_\d)[a-zA-Z0-9]+$/,
  //   "This field cannot contain white space and special character"
  // ),
});
export const countrySchema = yup.object().shape({
  name: yup
    .string()
    .required('Country name is required')
    .matches(/[A-Z]/, 'Enter first letter capital'),
  // .matches(
  //   /^(?![0-9])(?!.*[0-9]$)(?!.*\d_)(?!.*_\d)[a-zA-Z0-9]+$/,
  //   "This field cannot contain white space and special character"
  // ),
  code: yup.string().required('Code is required'),
  currency_code: yup.string().required('Currency Code is required'),
  country_code: yup
    .string()
    .required('Country Code is required')
    .matches(
      /^[+][0-9]*$/,
      'Please enter a plus sign (+) followed by numbers only'
    ),
});
export const stateSchema = yup.object().shape({
  name: yup
    .string()
    .required('State name is required')
    .matches(/[A-Z]/, 'Enter first letter capital'),
  // .matches(
  //   /^(?![0-9])(?!.*[0-9]$)(?!.*\d_)(?!.*_\d)[a-zA-Z0-9]+$/,
  //   "This field cannot contain white space and special character"
  // ),
  code: yup.string().required('Code is required'),
});
export const taxationSchema = yup.object().shape({
  taxation_name: yup
    .string()
    .required('Taxation name is required')
    .matches(/[A-Z]/, 'Enter first letter capital'),
  // .matches(
  //   /^(?![0-9])(?!.*[0-9]$)(?!.*\d_)(?!.*_\d)[a-zA-Z0-9]+$/,
  //   "This field cannot contain white space and special character"
  // ),
  tax_rate: yup
    .string()
    .required('Tax Rate is required')
    .matches(/[0-9]/, 'This field accept only numbers.'),
  taxation_type: yup.string().required('Taxation Type is required'),
  resource_type: yup.string().required('Resource Type is required'),
});
export const categorySchema = yup.object().shape({
  name: yup.string().required('Category name is required'),
});
export const QrcodeSchema = yup.object().shape({
  name: yup.string().required('QR Code is required'),
  // qr_type: yup
  // .string()
  // .required("QR Type is required")
});
export const stationSchema = yup.object().shape({
  name: yup.string().required('Station name is required'),
});
export const paymentModeSchema = yup.object().shape({
  mode: yup.string().required('Payment Mode is required'),
});
export const orderProcessSchema = yup.object().shape({
  name: yup.string().required('Order Process name is required'),
});
export const surveySchema = yup.object().shape({
  name: yup.string().required('Survey name is required'),
  // .matches(/[A-Z]/,"Enter first letter capital"),

  after_survey_content: yup
    .string()
    .required('After Survey content is required'),
  introduction: yup.string().required('Introduction is required'),
});
export const categoryItemsSchema = yup.object().shape({
  price: yup.string().required('Price is required'),
  name: yup.string().required('Item name is required'),
  description: yup.string().required('Description is required'),
});
export const employeeSchema = yup.object().shape({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
});
export const layoutSchema = yup.object().shape({
  layout_name: yup.string().required('Layout name is required'),
});
export const TableSchema = yup.object().shape({
  table_number: yup.string().required('Table Number is required'),
  seating_capacity: yup.number().required('Seating Capacity is required'),
  // organization_layout_id: yup
  //   .string()
  //   .required('Please Select atleast one Layout'),
});
export const userThemeSchema = yup.object().shape({
  primary_color: yup.string().required('Primary Color is required'),
  secondary_color: yup.string().required('Secondary Color is required'),
});
export const customizationSchema = yup.object().shape({
  name: yup.string().required('Customization Name is required'),
  max_selected: yup.string().required('Max Selected Items Allowed is required'),
});
export const customizationItemSchema = yup.object().shape({
  name: yup.string().required('Customization Item Name is required'),
  price: yup.string().required('Price is required'),
});
export const surveyQuestionSchema = yup.object().shape({
  question_text: yup.string().required('Question Text is required'),
  type: yup.string().required('Question type is required'),
});
export const orderProcessNotificationSchema = yup.object().shape({
  notification_text: yup.string().required('Notification text is required'),
});

export const SupplierSchema = yup.object().shape({
  supplier_name: yup.string().required('Supplier name is required'),
  company_name: yup.string().required('Company name is required'),
});
export const featureSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
});
export const featuresFlagSchema = yup.object().shape({
  feature_id: yup.string().required('Please Select atleast one Feature'),
});
export const languagesSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  code: yup.string().required('Code is required'),
});
export const waiterSchema = yup.object().shape({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  waiter_code: yup.string().required('Waiter code is required'),
});
export const linkedAccountSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Invalid email format'),
  phone: yup
    .string()
    .required('Phone number is required')
    .matches(/^[0-9]+$/, 'Phone number must be digits only')
    .min(8, 'Phone number must be at least 8 digits')
    .max(15, 'Phone number must be at most 15 digits'),
  legal_business_name: yup
    .string()
    .required('Business name is required')
    .min(4, 'Business name must be at least 4 characters')
    .max(200, 'Business name must be at most 200 characters'),
  contact_name: yup
    .string()
    .required('Contact name is required')
    .min(4, 'Contact name must be at least 4 characters')
    .max(255, 'Contact name must be at most 255 characters'),
  business_model: yup
    .string()
    .required('Business model is required')
    .min(1, 'Business model must be at least 1 characters')
    .max(255, 'Business model must be at most 255 characters'),
  business_type: yup.string().required('Business type is required'),
  subcategory: yup.string().required('Business subcategory is required'),
  street1: yup
    .string()
    .required('Address line 1 is required')
    .max(100, 'Address line 1 must be at most 100 characters'),
  street2: yup
    .string()
    .required('Address line 2 is required')
    .max(100, 'Address line 2 must be at most 100 characters'),
  city: yup
    .string()
    .required('City is required')
    .max(100, 'City must be at most 100 characters'),
  state: yup
    .string()
    .required('State is required')
    .min(2, 'State must be at least 2 characters')
    .max(32, 'State must be at most 32 characters'),
  postal_code: yup
    .string()
    .required('Postal code is required')
    .matches(/^\d{6}$/, 'Postal code must be exactly 6 digits'),

  operationstreet1: yup
    .string()
    .required('Address line 1 is required')
    .max(100, 'Address line 1 must be at most 100 characters'),
  operationstreet2: yup
    .string()
    .required('Address line 2 is required')
    .max(100, 'Address line 2 must be at most 100 characters'),
  operationcity: yup
    .string()
    .required('City is required')
    .max(100, 'City must be at most 100 characters'),
  operationstate: yup
    .string()
    .required('State is required')
    .min(2, 'State must be at least 2 characters')
    .max(32, 'State must be at most 32 characters'),
  operationpostalcode: yup
    .string()
    .required('Postal code is required')
    .matches(/^\d{6}$/, 'Postal code must be exactly 6 digits'),
  // pan: yup
  //   .string()
  //   .required('PAN number is required')
  //   .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format'),
  // gst: yup
  //   .string()
  //   .required('GST number is required')
  //   .matches(
  //     /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z][0-9][A-Z0-9][A-Z0-9]$/,
  //     'Invalid GSTIN format'
  //   ),
});

export const existingLinkedAccount = yup.object().shape({
  linked_account_id: yup
    .string()
    .required('Please Enter the linked account id'),
});
export const stackholderAccountSchema = yup.object().shape({
  name: yup
    .string()
    .required('Name is required')
    .max(255, 'Name must be at most 255 characters'),

  email: yup
    .string()
    .required('Email is required')
    .max(132, 'Email must be at most 132 characters')
    .email('Must be a valid email')
    .test('email-parts-length', 'Invalid email format', (value) => {
      if (!value) return false;
      const [local, domain] = value.split('@');
      return local?.length <= 64 && domain?.length <= 68;
    }),
  street: yup
    .string()
    .required('Address is required')
    .min(10, 'Street must be at least 10 characters')
    .max(255, 'Street must be at most 255 characters'),
  city: yup
    .string()
    .required('City is required')
    .min(2, 'City must be at least 2 characters')
    .max(32, 'City must be at most 32 characters'),
  state: yup
    .string()
    .required('State is required')
    .min(2, 'State must be at least 2 characters')
    .max(32, 'State must be at most 32 characters'),
  postal_code: yup
    .string()
    .required('Postal code is required')
    .min(2, 'Postal code must be at least 2 characters')
    .max(10, 'Postal code must be at most 10 characters'),
  pan: yup
    .string()
    .required('Pan number is required')
    .matches(
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      'PAN must be a valid 10-character alphanumeric code (e.g., AVOPB1234K)'
    )
    .test(
      'fourth-char-p',
      'The 4th character of PAN must be "P"',
      (value) => !value || value[3]?.toUpperCase() === 'P'
    ),
});
export const productConfigurationSchema = yup.object().shape({
  product_name: yup.string().required('Product name is required'),
});
export const updateProductConfigurationSchema = yup.object().shape({
  account_number: yup
    .string()
    .required('Account number is required')
    .matches(/^\d{9,18}$/, 'Account number must be 9 to 18 digits'),

  ifsc_code: yup
    .string()
    .required('IFSC code is required')
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter a valid IFSC code'),

  beneficiary_name: yup
    .string()
    .required('Beneficiary name is required')
    .min(2, 'Name is too short')
    .max(100, 'Name is too long'),
});
